export default "__VITE_ASSET__7391ad95__"